import React, { FunctionComponent, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { Router, useLocation } from '@reach/router';
import { useEthers } from '@usedapp/core';

import { NoView } from '../../../components/NoView';

import { CLIENT_ROUTES, ETH_CHAIN_NETWORKS } from '../../../context/constants';
import { useTrackedState } from '../../../context/store';

import { findProvider } from '../../../helpers';

import useRedirectOnPath from '../../../hooks/useRedirectOnPath';

import { FarmsConnectedView } from './FarmsConnectedView';
import { StyledContentBlock } from './styled';

export type FarmsView = '' | 'pending' | 'success' | 'error';

export const FarmsWidget: FunctionComponent = () => {
  const { formatMessage } = useIntl();
  const { provider: exchangeProvider } = useTrackedState();
  useRedirectOnPath();

  const { chainId } = useEthers();
  const location = useLocation();

  const [hideWidget, setHideWidget] = useState(false);
  const [view, setView] = useState<FarmsView>('');

  const provider = findProvider(exchangeProvider);
  const networkName = provider?.label;

  useEffect(() => {
    const hide =
      !location.pathname.includes('eth') || chainId !== 1 || !chainId;
    setHideWidget(hide);
  }, [chainId, location]);

  return (
    <StyledContentBlock>
      {hideWidget ? (
        <Router basepath="/farms">
          {CLIENT_ROUTES.map(path => (
            <NoView
              key={path}
              path={path}
              page="farms"
              title={formatMessage({
                id: 'farms.noView.title',
              })}
              subtitle={formatMessage({
                id: 'farms.noView.subtitle',
              })}
              switchProviderMsg={formatMessage({
                id: 'farms.noView.switchProvider',
              })}
              switchNetworkMsg={formatMessage(
                { id: 'farms.noView.switchNetwork' },
                { NETWORKNAME: networkName },
              )}
              invalidProvider={!ETH_CHAIN_NETWORKS.includes(exchangeProvider)}
              routesEnabled
            />
          ))}
        </Router>
      ) : (
        <FarmsConnectedView view={view} setView={setView} />
      )}
    </StyledContentBlock>
  );
};

export default FarmsWidget;
